import { Button, ButtonProps, Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom'

// https://mui.com/components/breadcrumbs/#integration-with-react-router

export type LinkProps = MuiLinkProps<
  'a',
  RouterLinkProps & {
    useButton?: boolean
    noRouter?: boolean
    buttonProps?: ButtonProps
  }
>

const Link = ({ to, ...props }: LinkProps) => {
  const { noRouter, useButton, underline = useButton ? 'none' : 'hover', children, buttonProps, ...linkProps } = props

  return (
    <MuiLink
      to={noRouter ? undefined : `${to}`}
      href={`${to}`}
      underline={underline}
      {...linkProps}
      component={noRouter ? 'a' : RouterLink}
    >
      {useButton ? <Button {...buttonProps}>{children}</Button> : children}
    </MuiLink>
  )
}

export default Link
